import {Component, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {vconsultation} from 'src/app/domain';


@Component({
    selector: 'app-consulationcards',
    templateUrl: './consulationcards.component.html',
    styleUrls: ['./consulationcards.component.css']
})
export class ConsulationcardsComponent implements OnInit {

    @ViewChild('carousel', {static: false}) carousel: any;
    @Input() listconsultations: vconsultation[];
    responsiveOptions;
    listappel: any;
    @Input() slides: any = [[]];
    // }
    CAROUSEL_BREAKPOINT = 768;
    carouselDisplayMode = 'multiple';

    constructor(private router: Router) {
        this.responsiveOptions = [
            {
                breakpoint: '1024px',
                numVisible: 3,
                numScroll: 3
            },
            {
                breakpoint: '768px',
                numVisible: 2,
                numScroll: 2
            },
            {
                breakpoint: '560px',
                numVisible: 1,
                numScroll: 1
            }
        ];
    }

    // chunk(arr, chunkSize) {
    //   let R = [];
    //   for (let i = 0, len = arr.length; i < len; i += chunkSize) {
    //     R.push(arr.slice(i, i + chunkSize));
    //   }
    //   return R;

    next() {
        this.carousel.nextSlide();
    }

    prev() {
        this.carousel.previousSlide();
    }

    ngOnInit() {
        // this.slides = this.chunk(this.listbid,4)

        if (window.innerWidth <= this.CAROUSEL_BREAKPOINT) {
            this.carouselDisplayMode = 'single';
        } else {
            this.carouselDisplayMode = 'multiple';
        }
    }

    @HostListener('window:resize')
    onWindowResize() {
        if (window.innerWidth <= this.CAROUSEL_BREAKPOINT) {
            this.carouselDisplayMode = 'single';
        } else {
            this.carouselDisplayMode = 'multiple';
        }
    }

    verstouslesconsultations(): void {
        this.router.navigateByUrl('/portail/consultations');
    }

    detailsconsultation(consultation: vconsultation) {
        this.router.navigate(['/portail/consultations/consultationdetails', consultation.spShopMasterId, consultation.shopNo]);
    }
}
